import { render, staticRenderFns } from "./ColumnName.vue?vue&type=template&id=745df490&scoped=true"
import script from "./ColumnName.vue?vue&type=script&lang=ts"
export * from "./ColumnName.vue?vue&type=script&lang=ts"
import style0 from "./ColumnName.vue?vue&type=style&index=0&id=745df490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745df490",
  null
  
)

export default component.exports